export default __webpack_public_path__ + "static/media/man.832e045f.png";